import { Box } from '@mui/material';
import Image from 'next/image';
import classes from './Hero.module.scss';
import TitleContainer from '../TitleContainer/TitleContainer';
import HeroLocation from './HeroLocation/HeroLocation';
const Hero: React.FC = () => {
  return <Box className={classes.hero} data-sentry-element="Box" data-sentry-component="Hero" data-sentry-source-file="Hero.tsx">
			<Box className={classes['hero-content']} data-sentry-element="Box" data-sentry-source-file="Hero.tsx">
				<TitleContainer title="Schedule Your Visit" description="Reserve a time online or walk in today." data-sentry-element="TitleContainer" data-sentry-source-file="Hero.tsx" />
				<HeroLocation data-sentry-element="HeroLocation" data-sentry-source-file="Hero.tsx" />
			</Box>
			<Box className={classes['hero-image-wrapper']} data-sentry-element="Box" data-sentry-source-file="Hero.tsx">
				<Image unoptimized src="https://cdn.bfldr.com/E8SG6JBO/at/8x9jk8cfgbs88f9fhqsn648x/hero-image.png?auto=webp&format=png" alt="Hero Image" width={731} height={731} className={classes['hero-image']} data-sentry-element="Image" data-sentry-source-file="Hero.tsx" />
			</Box>
		</Box>;
};
export default Hero;